/**
 * Created by orion on 6/24/17.
 */
import {DjangoUrls} from 'DjangoUrls';
import _ from 'lodash';
import axios from 'axios';

const PREFIX = "api.v1:calendar_events-";

const CalendarEventsResource = {
    create_calendar_event(targetData, eventData) {
        const url = DjangoUrls[PREFIX + "create-calendar-event"]();
        return axios({
            method: 'POST',
            url: url,
            data: _.merge({}, targetData, eventData)
        });
    },

    find_nearest_event_date(eventId) {
        const url = DjangoUrls[PREFIX + "find-nearest-event-date"](eventId);
        return axios({
            method: 'GET',
            url: url,
        });
    },

    get_event(eventId, date, calendarOwnerId) {
        const url = DjangoUrls[PREFIX + "get-event"](eventId);
        return axios({
            method: 'GET',
            url: url,
            params: {
                date,
                id: calendarOwnerId
            }
        });
    },

    get_event_period_info(id, date) {
        const url = DjangoUrls[PREFIX + "get-event-period-info"](id);
        return axios({
            method: 'GET',
            url: url,
            params: {date}
        });
    },

    join_event(id, calendar_owner_id, date, only_one_date = false) {
        const url = DjangoUrls[PREFIX + "join-event"](id);
        return axios({
            method: 'POST',
            url: url,
            data: {
                date,
                only_one_date,
                calendar_owner_id,
            }
        });
    },

    remove_from_calendar(id, calendar_owner_id, date, only_one_date = false) {
        const url = DjangoUrls[PREFIX + "remove-from-calendar"](id);
        return axios({
            method: 'POST',
            url: url,
            data: {
                date,
                only_one_date,
                calendar_owner_id,
            }
        });
    },

    remove_member(id, memberId, date, only_one_date = false) {
        const url = DjangoUrls[PREFIX + "remove-member"](id);
        return axios({
            method: 'POST',
            url: url,
            data: {
                date,
                only_one_date,
                id: memberId,
            }
        });
    },

    delete_event(id, data) {
        const url = DjangoUrls[PREFIX + "delete-event"](id);
        return axios({
            method: 'POST',
            url: url,
            data
        });
    },

    update_event_data(id, typeData, eventData) {
        const url = DjangoUrls[PREFIX + "update-event-data"](id);
        return axios({
            method: 'POST',
            url: url,
            data: _.merge({}, typeData, eventData)
        });
    },

    update_advanced_time_schedule(id, typeData, scheduleData) {
        const url = DjangoUrls[PREFIX + "update-advanced-time-schedule"](id);
        return axios({
            method: 'POST',
            url: url,
            data: _.merge({}, typeData, scheduleData)
        });
    },

    update_event_recurrence(id, recurrenceData) {
        const url = DjangoUrls[PREFIX + "update-event-recurrence"](id);
        return axios({
            method: 'POST',
            url: url,
            data: recurrenceData
        });
    },

    get_event_recurrence_info(eventId, calendar_owner_id, event_date) {
        const url = DjangoUrls[PREFIX + "get-event-recurrence-info"](eventId);
        return axios({
            method: 'GET',
            url: url,
            params: {
                event_date,
                calendar_owner_id
            }
        });
    },

    get_event_members(id, calendarOwnerId, date) {
        const url = DjangoUrls[PREFIX + "get-event-members"](id);
        return axios({
            method: 'GET',
            url: url,
            params: {
                date,
                calendar_owner_id: calendarOwnerId,
            }
        });
    },

    load_more_event_members(id, calendarOwnerId, date, limit, offset, group) {
        const url = DjangoUrls[PREFIX + "load-more-event-members"](id);
        return axios({
            method: 'GET',
            url: url,
            params: {
                date,
                limit,
                offset,
                group,
                calendar_owner_id: calendarOwnerId,
            }
        });
    },

    set_attendance(eventId, date, calendar_owner_id, attendance) {
        const url = DjangoUrls[PREFIX + "set-attendance"](eventId);
        return axios({
            method: 'POST',
            url: url,
            data: {
                date,
                calendar_owner_id,
                attendance
            }
        });
    },

    unset_attendance(eventId, date, calendar_owner_id) {
        const url = DjangoUrls[PREFIX + "unset-attendance"](eventId);
        return axios({
            method: 'POST',
            url: url,
            data: {
                date,
                calendar_owner_id,
            }
        });
    },

    check_access_and_join_ability(eventId, date) {
        const url = DjangoUrls[PREFIX + "check-access-and-join-ability"](eventId);
        return axios({
            method: 'GET',
            url: url,
            params: {
                date
            }
        });
    },

    get_users_for_invite(eventId, date, only_one_date = false, params) {
        const url = DjangoUrls[PREFIX + "get-users-for-invite"](eventId);
        return axios({
            method: 'GET',
            url,
            params: _.merge({date, only_one_date}, params)
        });
    },

    invite_users(eventId, id_list, date, only_one_date = false) {
        const url = DjangoUrls[PREFIX + "invite-users"](eventId);
        return axios({
            method: 'POST',
            url,
            data: {
                id_list,
                date,
                only_one_date
            }
        });
    },

    get_going_members(eventId, calendarOwnerId, date) {
        const url = DjangoUrls[PREFIX + "get-going-members"](eventId);
        return axios({
            method: 'GET',
            url,
            params: {
                date,
                calendar_owner_id: calendarOwnerId,
            }
        });
    },

    get_event_occurrences_in_month(eventId, calendarOwnerId, eventDate, dateInRequestedMonth) {
        const url = DjangoUrls[PREFIX + "get-event-occurrences-in-month"](eventId);
        return axios({
            method: 'GET',
            url,
            params: {
                date: dateInRequestedMonth,
                event_date: eventDate,
                calendar_owner_id: calendarOwnerId,
            }
        });
    },

    get_groups_to_create_event(params) {
        const url = DjangoUrls[PREFIX + "get-groups-to-create-event"]();
        return axios({
            method: 'GET',
            url,
            params
        });
    },

    get_groups_to_create_circle_group_event(circleOwnerId, params) {
        const url = DjangoUrls[PREFIX + "get-groups-to-create-circle-group-event"]();
        return axios({
            method: 'GET',
            url,
            params: Object.assign({id: circleOwnerId}, params)
        });
    },

    get_communities_to_create_event(params) {
        const url = DjangoUrls[PREFIX + "get-communities-to-create-event"]();
        return axios({
            method: 'GET',
            url,
            params
        });
    },
};

export default CalendarEventsResource;
